import { Link } from 'react-router-dom';

const stats = [
  { value: '18+', label: 'лет практики' },
  { value: '100+', label: 'корпоративных проектов' },
  { value: '450+', label: 'тренингов и бизнес-сессий' },
  { value: '4500+', label: 'участников' },
  { value: '9,09/10', label: 'средняя оценка участников' },
];

export default function AboutTrainer() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2">
              Кто проводит обучение
            </h2>
            <p className="text-xl text-teal-700 font-semibold mb-6">Алексей Сивко</p>

            <p className="text-base text-gray-600 leading-relaxed mb-4">
              Практикующий бизнес-тренер, консультант, фасилитатор и сертифицированный коуч ICU. Специализируюсь на развитии руководителей и управленческих команд.
            </p>

            <p className="text-base text-gray-600 leading-relaxed mb-4">
              Практическая работа с переговорами, продажами и управленческими задачами позволяет переносить в обучение реальные ситуации бизнеса, а не ограничиваться теорией.
            </p>

            <p className="text-sm text-gray-500 mb-6">
              Работал с компаниями Беларуси, России, Казахстана и Израиля.
            </p>

            <Link
              to="/o-trenere"
              className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              Подробнее о тренере
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0 border-2 border-teal-200">
                <img
                  src="https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/a74b8d07-08c1-4959-a4cf-b4c9559a793b_compressed_Image156.webp"
                  alt="Алексей Сивко"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Алексей Сивко</h3>
                <p className="text-sm text-gray-500">Бизнес-тренер, консультант, коуч ICU</p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {stats.map((stat, i) => (
                <div key={i} className="bg-gray-50 rounded-xl p-3 text-center border border-gray-100">
                  <div className="text-xl md:text-2xl font-extrabold text-teal-600">{stat.value}</div>
                  <div className="text-gray-500 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}